// Copyright (c) 2022 by Move Closer

import { MappingConfig, MappingTypes } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const fileAdapterMap: MappingConfig = {
  size: {
    type: MappingTypes.Function,
    value: item => item.toString()
  }
}
